import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../../AbstractElements';
import UploadMonthlySalesView from './uploadMonthlySales';
import { Container } from 'reactstrap';

const UploadMonthlySales = () => {
    // Same rule as the sidebar: user group has Access Audit and the concessionaire has audit enabled
    if (localStorage.getItem("accessAudit") !== "1" || localStorage.getItem("auditRequired") !== "true") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
        return null;
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Audit" title="Upload Monthly Sales" mainTitle="Upload Monthly Sales" />
                <Container fluid={true}>
                    <UploadMonthlySalesView />
                </Container>
            </Fragment>
        </UL>
    )
}

export default UploadMonthlySales